<template>
  <div id="fooder">
    <footer class="footer">
      <div class="footer-top">
        <ul class="footer-list">
          <li class="footer-tit">产品服务</li>
          <li class="footer-desc">
            <a
              href="http://school-admin.risfond.com/"
              target="_blank"
              class="footer-desc-link"
              >企业入口</a
            >
          </li>
          <li class="footer-desc">
            <a
              href="http://www.risfond.com/"
              target="_blank"
              class="footer-desc-link"
              >关于我们</a
            >
          </li>
        </ul>
        <ul class="footer-list">
          <li class="footer-tit">联系方式</li>
          <li class="footer-desc">服务热线：18810011177 (9:00 - 18:00）</li>
          <li class="footer-desc">企业服务邮箱：rsxy@risfond.com</li>
        </ul>
        <ul class="footer-xcx-wrap">
          <li class="footer-xcx">
            <img
              src="@/assets/img/jingying.jpg"
              class="footer-xcx-logo"
              alt=""
            />
            <p class="footer-xcx-desc">锐仕精英</p>
          </li>
          <li class="footer-xcx">
            <img
              src="@/assets/img/weipin.jpeg"
              class="footer-xcx-logo"
              alt=""
            />
            <p class="footer-xcx-desc">微聘</p>
          </li>
        </ul>
      </div>
      <div class="footer-b">
        <div class="footer-wrap">
          <p>
            京ICP备09057085号-3 | 京公网安备110108400108号 ｜ 版权所有 ©
            2008-2021锐仕方达人才科技集团有限公司
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: "Fooder",
};
</script>
<style scoped>
#fooder {
  flex: 1;
  display: flex !important;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  background: #f5f5f5;
}
.footer {
  background: #272e3e;
}
.footer-wrap,
.footer-top {
  width: 1200px;
  margin: 0 auto;
}
.footer-b {
  border: 1px solid #323a4c;
  padding: 11px 0;
  text-align: center;
}
.footer-wrap p {
  color: #999;
  line-height: 28px;
}
.footer-top {
  display: flex;
  padding: 33px 0 26px;
}
.footer-list {
  margin-right: 115px;
}
.footer-tit {
  color: #fff;
  font-size: 18px;
  margin-bottom: 14px;
}
.footer-desc {
  color: #999;
  padding-bottom: 12px;
}
.footer-desc-link {
  color: #999;
}
.footer-desc-link:hover {
  color: #fff;
}
.footer-xcx-wrap {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}
.footer-xcx {
  text-align: center;
  margin-left: 30px;
}
.footer-xcx-desc {
  color: #fff;
  margin-top: 12px;
}
.footer-xcx-logo {
  width: 80px;
  height: 80px;
}
</style>
